import React, { useState } from 'react';
import axios from 'axios';

interface LoginProps {
  onLogin: (token: string, user: { username: string; is_admin: number }) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    const isProd = process.env.NODE_ENV === 'production';
    const loginUrl = isProd ? '/api/login' : `http://${window.location.hostname}:4658/api/login`;
    e.preventDefault();
    try {
      const response = await axios.post(loginUrl, { username, password });
      onLogin(response.data.token, response.data.user);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Login fehlgeschlagen');
    }
  };

  return (
    <div className="login-container" style={{ maxWidth: '400px', margin: '60px auto', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <img 
        src={`${process.env.PUBLIC_URL}/vahrschule logo.png`} 
        alt="Vahrschule Logo" 
        style={{ width: '100%', maxWidth: '250px', marginBottom: '40px' }} 
      />
      
      <div className="card" style={{ width: '100%', padding: '20px', boxSizing: 'border-box' }}>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: 'var(--text-secondary)' }}>Benutzername</label>
            <input 
              className="input-field"
              type="text" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              required 
              style={{ marginBottom: 0 }}
            />
          </div>
          <div style={{ marginBottom: '25px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: 'var(--text-secondary)' }}>Passwort</label>
            <input 
              className="input-field"
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
              style={{ marginBottom: 0 }}
            />
          </div>
          {error && <div style={{ color: '#e53e3e', marginBottom: '15px', textAlign: 'center', fontWeight: 'bold' }}>{error}</div>}
          <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '12px', fontSize: '1.1rem' }}>Anmelden</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
